import React from 'react'
import { Card, Typography, Button } from 'antd'
import { MedicineBoxOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { CARD_STYLES, CARD_GRADIENTS } from '../utils/constants'
import coreReducer from '../../../../../../core/utils/reducer'
import CoreEnums from '../../../../../../core/utils/enums'
import DesktopMedicalHistoryWrapper from '../../../../Medical History/desktop/components/DesktopMedicalHistoryWrapper'

const { Paragraph } = Typography

const ProfileHistoryCard = () => {
  const dispatch = useDispatch()

  const handleNavigateToMedicalHistory = () => {
    dispatch(
      coreReducer.actions.addTab({
        key: CoreEnums.tabKeys.NEW_MEDICAL_HISTORY,
        closable: true,
        label: CoreEnums.tabTitles.NEW_MEDICAL_HISTORY,
        children: <DesktopMedicalHistoryWrapper isPatient />
      })
    )
  }

  return (
    <Card
      title='Medical History Management'
      bordered={false}
      style={{
        boxShadow: CARD_STYLES.shadow,
        borderRadius: CARD_STYLES.borderRadius,
        height: '100%'
      }}
      headStyle={{
        background: CARD_GRADIENTS.purple,
        color: 'white',
        borderRadius: '12px 12px 0 0',
        fontWeight: '600'
      }}
    >
      <div style={{ marginBottom: '20px', color: '#595959', lineHeight: '1.6' }}>
        <Paragraph style={{ marginBottom: '12px', color: '#595959', fontSize: '14px' }}>
          Maintaining an accurate medical history is crucial for your healthcare:
        </Paragraph>
        <ul style={{ margin: '0', paddingLeft: '20px', color: '#595959', fontSize: '14px', lineHeight: '1.6' }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Informed decisions</strong> - Helps doctors make better treatment choices
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Safety first</strong> - Prevents dangerous drug interactions and allergic reactions
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Personalised care</strong> - Enables customised treatment plans for your specific needs
          </li>
          <li style={{ marginBottom: '0px' }}>
            <strong>Emergency readiness</strong> - Critical information available when you need it most
          </li>
        </ul>
      </div>
      <Button type='primary' icon={<MedicineBoxOutlined />} block onClick={handleNavigateToMedicalHistory}>
        Manage Medical History
      </Button>
    </Card>
  )
}

export default ProfileHistoryCard
